import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.7 11.3c-.4-.4-1-.4-1.4 0L13 14.6V5c0-2.8-2.2-5-5-5H1C.4 0 0 .4 0 1s.4 1 1 1h7c1.7 0 3 1.3 3 3v9.6l-3.3-3.3c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l5 5c.1.1.2.2.3.2.1.1.3.1.4.1s.3 0 .4-.1.2-.1.3-.2l5-5c.4-.4.4-1 0-1.4"
    }, null, -1)
  ]))]))
}
export default { render: render }